import { criteriaMatches, parseHSPCriteria } from '@swf/poker';

import type { PPDataType, PassBundleRaw, StepKey } from '../types';
import { PowerPathType, StepKeyName } from '../types';

export const getPPDataTypeKey = (dataType: string): PPDataType =>
  dataType === 'mock' ? 'mock' : 'real';

export const generateStepKey = (step: number, type: PowerPathType): StepKey => {
  if (step === 1) {
    return StepKeyName.step1;
  } else if (step === 2) {
    if (type === PowerPathType.SIT_AND_GO) {
      return StepKeyName.step2SNG;
    }
    return StepKeyName.step2Scheduled;
  } else if (step === 3) {
    return StepKeyName.step3;
  } else if (step === 4) {
    return StepKeyName.step4;
  }
  throw new Error('Invalid step or type provided');
};

export const normalizePassesResponse = (passesResponse: PassBundleRaw, site: string) => {
  const hasMatchingCriteria = Object.values(passesResponse)
    .flat()
    .find((filtersConfig) => {
      const parsedCriteria = parseHSPCriteria(filtersConfig.targeting);
      return criteriaMatches(parsedCriteria, { site: [site.toLowerCase()] });
    });

  if (!hasMatchingCriteria) return null;

  return {
    gold: (passesResponse.gold ?? []).sort((a, b) => a.order - b.order),
    silver: (passesResponse.silver ?? []).sort((a, b) => a.order - b.order),
    bronze: (passesResponse.bronze ?? []).sort((a, b) => a.order - b.order)
  };
};
